/**
 * Office add-in WebView2 compatibility shims.
 *
 * Must be imported FIRST in every bundle entry that touches Clerk
 * (e.g. taskpane.ts). The History API exposed inside an Office task
 * pane / dialog iframe is restricted and may be missing methods that
 * third-party SDKs assume are present.
 *
 * Clerk specifically: its dev-mode setup (`Ti.load > yi.setupDevelopment`)
 * calls `globalThis.history.replaceState` during initialization. In a
 * WebView2 Office iframe, that property is missing or non-callable,
 * causing `clerk.load()` to throw before the sign-in UI can render.
 *
 * We don't use URL-based routing in v0, so a no-op is safe.
 */

function noop(): void {
  // intentionally empty
}

function ensureFn(obj: object, prop: string): void {
  const o = obj as Record<string, unknown>;
  if (typeof o[prop] === "function") return;
  try {
    Object.defineProperty(obj, prop, {
      value: noop,
      writable: true,
      configurable: true,
    });
  } catch {
    // Property descriptor refused (frozen object, etc.). Nothing more we
    // can do at the language level; downstream SDK errors will be louder
    // and more diagnosable than swallowing this here.
  }
}

if (typeof globalThis !== "undefined") {
  const h = (globalThis as { history?: object }).history;
  if (h) {
    ensureFn(h, "replaceState");
    ensureFn(h, "pushState");
  }
}
